module.exports = __webpack_public_path__ + "static/assets/50925bb01327c1ae49d3571f65e6f33e.png";